import React, { useState } from 'react';
import Navigation from '../components/organisms/Navigation';
import HeroSection from '../components/organisms/HeroSection';
import ShowreelTeaser from '../components/organisms/ShowreelTeaser';
import FeaturedWork from '../components/organisms/FeaturedWork';
import Services from '../components/organisms/Services';
import Testimonials from '../components/organisms/Testimonials';
import FAQSection from '../components/organisms/FAQSection';
import PreFooter from '../components/organisms/PreFooter';
import Footer from '../components/organisms/Footer';
import VideoModal from '../components/organisms/VideoModal';
import PageTransition from '../components/templates/PageTransition';
import SEO from '../components/utils/SEO';

const Home = () => {
    const [videoModalOpen, setVideoModalOpen] = useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <PageTransition>
            <SEO
                title="Home"
                description="Strategic web developer taking high-stakes founders from zero to market dominance. Custom digital ecosystems, no agency bloat."
            />
            <main className="relative z-10">
                <Navigation onVideoClick={() => setVideoModalOpen(true)} />
                <HeroSection />
                <ShowreelTeaser onVideoClick={() => setVideoModalOpen(true)} />
                <FeaturedWork />
                <Services />
                <Testimonials />
                <FAQSection />
                <PreFooter />
                <Footer />
            </main>

            <VideoModal
                isOpen={videoModalOpen}
                onClose={() => setVideoModalOpen(false)}
            />
        </PageTransition>
    );
};

export default Home;
